module.exports = __webpack_public_path__ + "static/media/siren-on.8052ba1f.svg";